import { render, staticRenderFns } from "./core_column.vue?vue&type=template&id=96f606ae"
import script from "./core_column.vue?vue&type=script&lang=js"
export * from "./core_column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports